(function(){
  function init(root){
    const slides = Array.from(root.querySelectorAll('.rph__slide'));
    const tabs   = Array.from(root.querySelectorAll('.rph__tab'));
    if (!slides.length || !tabs.length) return;

    let activeId = root.dataset.active || slides[0].dataset.id;

    function setActive(id){
      if (!id || id === activeId) return;
      activeId = id;
      root.dataset.active = id;

      tabs.forEach(btn => {
        const isActive = btn.dataset.id === id;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.tabIndex = isActive ? 0 : -1;
      });

      slides.forEach(s => {
        const v = s.querySelector('video');
        if (!v) return;
        if (s.dataset.id === id) {
          try { v.play(); } catch(e) {}
        } else {
          try { v.pause(); } catch(e) {}
        }
      });
    }

    // init
    setActive(activeId);

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.id;
        const targetSel = btn.dataset.target;
        const target = targetSel ? root.querySelector(targetSel) : null;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(id);
      }, { passive: true });
    });

    const io = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      setActive(visible.target.dataset.id);
    }, {
      root: null,
      threshold: [0.01, 0.15, 0.25, 0.5, 0.75],
      rootMargin: "-20% 0px -60% 0px"
    });

    slides.forEach(slide => io.observe(slide));
  }

  function boot(){
    document.querySelectorAll('.rph[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
